import React from 'react';
import { ChevronDown, Terminal, ChevronRight } from 'lucide-react';
import HeroGlobe from './HeroGlobe'; // Import the new component
import './Hero.css';

const Hero = ({ data }) => {
  const scrollToSkills = () => {
    const element = document.getElementById('skills');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero-section" id="hero">
      
      {/* --- BACKGROUND LAYER: 3D WORLD --- */}
      <div className="hero-background-layer">
        <HeroGlobe />
      </div>

      <div className="hero-container">
        
        {/* --- LEFT SIDE: INTEL --- */}
        <div className="hero-content">
          <div className="hero-badge">
            <span className="blink-dot"></span>
            SYSTEM_STATUS: SECURE
          </div>
          
          <h2 className="hero-headline">
            <span className="glitch-text" data-text="DEFENDING">Ayan Bhowal</span>
            <br />
            <span className="highlight-cyan">Product Security </span>
          </h2>
          
          <h1 className="hero-subheadline">
            <strong>Specializing </strong>
            <span style={{ fontSize: '0.9em', fontWeight: '400' }}>
              in Threat Modeling, AppSec Pipelines, and SOC Operations. 
              Transforming vulnerabilities into fortified infrastructure.
            </span>
          </h1>

          <div className="hero-actions">
            <button className="cyber-btn primary" onClick={scrollToSkills}>
              <Terminal size={18} />
              <span>Explore my work</span>
            </button>
            
            <button 
              className="cyber-btn secondary" 
              onClick={() => window.open("https://drive.google.com/file/d/1dMwkLW9i9G5DoUaKGsd7ZV4AKQneCBLx/view?usp=drive_link", "_blank")}
            >
              <span>VIEW_CV</span>
              <ChevronRight size={18} />
            </button>
          </div>

          <div className="hero-stats">
            <div className="stat-item">
              <span className="stat-val">500+</span>
              <span className="stat-label">VULNS PATCHED</span>
            </div>
            <div className="stat-item">
              <span className="stat-val">100%</span>
              <span className="stat-label">HIPAA COMPLIANT</span>
            </div>
          </div>
        </div>

        {/* --- RIGHT SIDE SPACER --- */}
        {/* We keep this empty div to maintain the grid layout so text stays on the left 
            while the 3D object (positioned manually in Three.js) occupies this visual space */}
        <div className="hero-spacer"></div>

      </div>

      <div className="hero-scroll-indicator" onClick={scrollToSkills}>
        <div className="scroll-line"></div>
        <ChevronDown className="scroll-icon" size={24} />
      </div>
    </section>
  );
};

export default Hero;